<ngx-loading [show]="loading" [config]="{ fullScreenBackdrop : true }"></ngx-loading>
<app-pulsemenu></app-pulsemenu>
<div class="container " *ngIf="doctor && doctor.length>0 && service" style="margin-top:10px">

<div class="row" >

  <div class="col-12"  *ngFor="let data of doctor |onlinedoc:  service | special: special | geolocationdistance : currentLocation
  | paginate: { itemsPerPage: 10, currentPage: p}" >

  
  <div *ngIf="data != 0 ; else nodocs"class="card" style="color: #cb983f" style="margin-top: 2%" >
        <div class="card-body" >
            <div class="row">
                <div class="col-sm-12 col-md-3 col-lg-3 col-xl-3">
                        <img class="card-img-top" style="height:150px" src="https://passport.petcart.in/images/userimgs/{{data.photo}}"
                        alt="image description"  routerLink="/pulse/doctordetail/{{data.id}}">
                </div>
                <div class="col-sm-12 col-md-5 col-lg-5 col-xl-5">
                        <h4 class="card-title"  routerLink="/pulse/doctordetail/{{data.id}}">{{data.name}}</h4>
                        <p class="card-text"  routerLink="/pulse/doctordetail/{{data.id}}">{{data.qualification}}</p>
                        <p class="card-text"  routerLink="/pulse/doctordetail/{{data.id}}">{{data.experience}}</p>
                        <div class="row">
                                <div class="col-2">
                                    <mat-icon>place</mat-icon>
                                </div>
                                <div class="col-10">
                                    {{data.address}}
                                </div>
                              </div>
                              <p style="cursor: pointer; color:#9b7544" *ngIf="data.distance">{{data.distance}} km
                                  (Approx Arial Distance) <br>-
                                  <a (click)="getDirection(data.lat, data.lon)">Click Here</a> to view Actual Distance and Direction
                              </p>
                </div>
            <div class="col-sm-12 col-md-4 col-lg-4 col-xl-4" *ngIf="servicemunus && services">
               <!-- <div class="col-12 text-center">
                    <p style="font-size:18px; color:#9b7544" >
                       <button (click)="showServices(data.id)"> <strong>SERVICES</strong> </button>
                    </p>
                </div>-->

                <!--<div  *ngFor="let menu of servicemunus" >
                    <div *ngIf="menu.serviceprovider_id == data.id">
                            <div *ngFor="let s of services">
                                <div class="row">
                                        <div class="col text-center" *ngIf="menu.service_id == s.id" > {{s.name}}</div>
                                        <div class="col text-center" *ngIf="menu.service_id == s.id"> {{menu.fees}}   </div>
                                </div>
                            </div>
                    </div>
                    </div> -->
                    <div *ngIf="services && services.length > 0 && servicemunus && servicemunus.length > 0">
                    <div *ngFor="let s of services">
                    <div *ngFor="let sm of servicemunus" >
                        <div style="color: #9b7455" class="col-6" 
                        *ngIf="data.id === sm.serviceprovider_id && s.id == sm.service_id && s.name === 'Text Chat'">
                            Text Chat: Rs {{sm.fees}}
                        </div>
                        <div style="color: #9b7455" class="col-6"
                        *ngIf="data.id === sm.serviceprovider_id && s.id == sm.service_id && s.name === 'Video Chat'">
                             Video Chat: Rs {{sm.fees}}
                            </div>
                    </div>
                    </div>
                    </div>
                    <div class="row" style="margin-top:50px">
                            <button *ngIf="checkAvailablitywithmitter(data.user_id) == 0; else notavailable"
                            class="btn btn-success btn-block" end clear style="margin-bottom: 1%"
                            (click)= "checkOnline(data.id,data.user_id)">Book Chat</button>
                        </div>
                </div>
            </div>
            </div>
        </div>


    </div>
  </div>
  <div class="row" *ngIf="doctor">
        <div class="col-12 text-right" style="font-size:18px ; color:#9b7544">
            <pagination-controls  (pageChange)="p = $event"></pagination-controls >
        </div>
      </div>
</div>


<ng-template #notavailable>
    <div class="row" style="margin-top:50px">
        <button
        class="btn btn-success btn-block" end clear style="margin-bottom: 1%">Not Available At this Moment</button>
    </div>
</ng-template>

<ng-template #nodocs>
        <div class="row" style="margin-top:100px; margin-bottom: 400px; color: #9b7544">
            <h2
            end clear style="margin-bottom: 1%">Currently there is no Doctor Online. We are working towards 
            adding more experts. If you want us to notify when a doctor comes online; please drop us a note to contact@petcart.com.
        </h2>
        </div>
    </ng-template>
